import React from 'react'
import { connect } from 'react-redux'
import Path from '@leverege/path'
import PropTypes from 'prop-types'

import { BreadcrumbActions, SystemActions, EventActions } from '../../actions'
import QueryScreen from './QueryScreen'

class SystemHistoryScreen extends React.Component {

  componentDidMount() {
    const { dispatch, match : { params : { systemId } } } = this.props

    dispatch( SystemActions.get( systemId ) )
  }

  componentDidUpdate( prevProps, prevState ) {
    // TODO : move out to device/system/project history page
    // get blueprint if we need it
    const { dispatch, match : { params : { projectId, systemId } }, systems } = this.props
    const { oldDevices } = prevProps

    const sName = Path( [ 'lookup', systemId, 'name' ] ).get( systems, null )
    dispatch( BreadcrumbActions.setBreadcrumbs( 
      [
        { name : 'Systems', link : `/project/${projectId}/system` }, 
        { name : sName || systemId, link : `/project/${projectId}/system/${systemId}/` }
      ]
    ) )
  }

  getResultsDisplayers = ( query, results ) => {
    if ( query && query.paths && query.paths.length > 1 ) {
      return [ 'table', 'blob' ]
    }
    return [ 'blob' ]
  }

  render() {
    const { match : { params : { systemId } }, location, history, events } = this.props

    return (
      <QueryScreen events={events} title="System Events" actions={EventActions} mapSeriesKey="deviceId" location={location} history={history} queryName="defaultSystem" queryType="system" queryable={systemId} resultsDisplayers={this.getResultsDisplayers} />
    )
  }
}

export default connect(
  state => ( {
    systems : state.systems,
    events : state.events
  } )
)( SystemHistoryScreen )
